<template>
  <div class="profile">
    <!-- 用户信息卡片 -->
    <div class="user-card">
      <div class="user-info">
        <div style="position:relative;">
          <van-image
            class="avatar"
            :src="isLoggedIn ?userInfo.avatar : require('@/assets/logo_user.png')"
            round
            
          />
     
        </div>
        <div class="user-details">
          <div class="user-name-row">
            <h3>{{ isLoggedIn ? userInfo.username : '游客' }}</h3>
          </div>
          <p>{{ isLoggedIn ? 'ID:'+userInfo.userId : '点击下方立即登录获取更多功能' }}</p>
          <!-- 用户状态标签 -->
          <div class="user-status" v-if="isLoggedIn">
            <van-tag 
              v-if="userInfo.isVip==0 && null!=userInfo.vipExpireDate" 
              type="danger" 
              size="mini"
              style="margin-right: 4px;"
            >
              商家VIP({{ '等级'+userInfo.level }})
            </van-tag>
            <van-tag 
              v-if="userInfo.isVip==1 || !userInfo.vipExpireDate" 
              type="default" 
              size="mini"
              style="margin-right: 4px;"
            >
              商家VIP(已过期)
            </van-tag>
          </div>
          <div v-if="isLoggedIn" style="color: #666;padding-top: 5px;font-weight: bold;">VIP:{{ userInfo.vipExpireDate }}</div>
          <div @click="copyInviteCode()" v-if="isLoggedIn" style="margin-top: 5px;color: #1989fa;font-weight: bold;font-size: 14px;">
            邀请码: {{userInfo.inviteCode || '无'}}<van-icon name="description" />
          </div>
        
        </div>
      </div>
      <!-- <van-button 
        v-if="isLoggedIn" 
        type="primary" 
        size="small"
      >
        编辑资料
      </van-button> -->
    </div>
    <div class="wallet-card" @click="toWallet()"> 
      <div class="wallet-info">
        <div class="wallet-label">钱包余额</div>
        <div class="wallet-amount">
          <span class="currency"></span>
          <span class="amount">{{isLoggedIn?userInfo.accountBalance: '0.00'}}</span>
        </div>
      </div>
      <div class="wallet-icon">
        <van-icon name="balance-o" size="28" />
      </div>
    </div>

    <!-- 功能菜单 -->
    <div class="menu-section" v-if="isLoggedIn">
      <div style="padding-left: 20px;font-size: 16px;font-weight: bold;">我的交易</div>
      <van-grid :border="false" style="background-color: #f7f8fa;">
        <van-grid-item icon="cash-back-record-o" text="资金明细" to="/paymentHistory" :badge="tranTotal.fundCnt"/>
        <van-grid-item icon="orders-o" text="代充记录" to="/proxyPlayHistory" :badge="tranTotal.proxyCnt"/>
        <van-grid-item :icon="require('../assets/goumai.jpg')" text="购买记录" to="/shopHistory" :badge="tranTotal.buyCnt"/>
        <van-grid-item :icon="require('../assets/chushou.jpg')" text="出售记录" to="/sellHistory" :badge="tranTotal.sellerCnt"/>
        <van-grid-item :icon="require('../assets/huis.jpg')" text="回收记录" to="/back" :badge="tranTotal.recyclerCnt"/>
        
      </van-grid>
      <div style="padding-left: 20px;font-size: 16px;font-weight: bold;">我的服务</div>
      <van-grid :border="false" style="background-color: #f7f8fa;">
        <van-grid-item icon="user-o" text="个人中心" to="/myInfo"/>
        <van-grid-item icon="vip-card-o" text="成为商户" to="/registermerchant"/>
        <!-- <van-grid-item icon="shield-o" text="实名认证"  @click="toUserauth()"/> -->
        <!-- <van-grid-item icon="chat-o" text="消息中心" to="/message" :badge="userInfo.unread"/> -->
        <van-grid-item icon="service-o" text="客服中心" @click="toChat()"/>
      </van-grid>
    
      <!-- <van-cell-group>
        <van-cell
          v-for="menu in menuList"
          :key="menu.id"
          :title="menu.title"
          :icon="menu.icon"
          is-link
          @click="onMenuClick(menu)"
        >
          <template #right-icon>
            <van-badge 
              v-if="menu.dot"
              :content="menu.dot"
              style="margin-right: 8px;width: 20px;height:20px;border-radius: 50%;line-height: 20px"
            />
            <van-icon name="arrow" />
          </template>
        </van-cell>
      </van-cell-group> -->
    </div>

    <!-- 游客提示信息 -->
    <div class="guest-info" v-if="!isLoggedIn">
      <div style="padding-left: 20px;font-size: 16px;font-weight: bold;">我的交易</div>
      <van-grid :border="false" style="background-color: #f7f8fa;">
        <van-grid-item icon="cash-back-record-o" text="资金明细" />
        <van-grid-item icon="orders-o" text="代充记录"/>
        <van-grid-item icon="orders-o" text="购买记录" />
        <van-grid-item icon="orders-o" text="出售记录" />
        <van-grid-item :icon="require('../assets/huis.jpg')" text="回收记录"/>
      </van-grid>
      <div style="padding-left: 20px;font-size: 16px;font-weight: bold;">我的服务</div>
      <van-grid :border="false" style="background-color: #f7f8fa;">
        <van-grid-item icon="user-o" text="个人中心" />
        <van-grid-item icon="vip-card-o" text="成为商户" />
        <van-grid-item icon="service-o" text="客服中心" />
      </van-grid>
      <!-- <van-cell-group>
        <van-cell
          v-for="menu in menuList"
          :key="menu.id"
          :title="menu.title"
          :icon="menu.icon"
          is-link
        >
          
        </van-cell>
      </van-cell-group> -->
    </div>

    <div class="auth-section">
      <van-button 
        v-if="!isLoggedIn"
        type="primary" 
        block 
        @click="onLogin"
      >
        立即登录
      </van-button>
      <van-button 
        v-else
        type="danger" 
        block 
        @click="onLogout"
      >
        退出登录
      </van-button>
    </div>
    
    <!-- <van-tabbar route >
      <van-tabbar-item replace to="/" icon="home-o" >首页</van-tabbar-item>
      <van-tabbar-item replace to="/market"  icon="search">市场</van-tabbar-item>
      <van-tabbar-item replace to="/stock"  icon="shop-o">出售</van-tabbar-item>
      <van-tabbar-item replace to="/back"  icon="after-sale">回收</van-tabbar-item>
      <van-tabbar-item replace to="/proxyPlay"  icon="diamond-o">代充</van-tabbar-item>
      <van-tabbar-item replace to="/profile"  icon="user-o">我的</van-tabbar-item>
    </van-tabbar> -->

    <van-popup v-model:show="showLoginForm" position="center" round>
    <div class="login-form">
      <h3 class="form-title">登录/注册</h3>
      
      <!-- 登录方式切换 -->
      <div class="login-type-tabs" style="display: flex; margin: 0 20px 10px;">
        <span 
          :class="{'active-tab': loginForm.loginType === 'phone', 'inactive-tab': loginForm.loginType !== 'phone'}" 
          @click="switchLoginType('phone')"
          style="flex: 1; text-align: center; cursor: pointer; padding: 8px 0; font-size: 14px;"
        >
          手机登录
        </span>
        <span 
          :class="{'active-tab': loginForm.loginType === 'email', 'inactive-tab': loginForm.loginType !== 'email'}" 
          @click="switchLoginType('email')"
          style="flex: 1; text-align: center; cursor: pointer; padding: 8px 0; font-size: 14px;"
        >
          邮箱登录
        </span>
      </div>
      
      <van-form @submit="handleLogin">
        <van-cell-group inset>
          <!-- 手机号输入或邮箱输入 -->
          <van-field
            v-if="loginForm.loginType === 'phone'"
            v-model="loginForm.phone"
            type="tel"
            label="手机号"
            placeholder="请输入手机号"
            :rules="[{ required: true, message: '请输入手机号' }]"
          />
          
          <van-field
            v-else
            v-model="loginForm.email"
            type="text"
            label="邮箱"
            placeholder="请输入邮箱地址"
            :rules="[
              { required: true, message: '请输入邮箱地址' },
              { 
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: '请输入正确的邮箱格式'
              }
            ]"
          />
          
          <van-field
            v-model="loginForm.smsCode"
            center
            label="验证码"
            placeholder="请输入验证码"
            :rules="[{ 
              required: true, 
              message: '请输入验证码' 
            }, { 
              pattern: /^\d{6}$/, 
              message: '验证码必须是6位数字'
            }]"
          >
            <template #button>
              <van-button
                size="small"
                type="primary"
                :disabled="isSmsSending"
                @click="sendSmsCode"
              >
                {{ smsButtonText }}
              </van-button>
            </template>
          </van-field>
          <van-field
            v-model="loginForm.inviteCode"
            label="邀请码"
            placeholder="请输入邀请码（选填）"
          />
        </van-cell-group>
        <div style="margin: 16px">
          <van-checkbox v-model="loginForm.agreement" shape="square">
            <template #default>
              <span class="agreement-text">
                我已阅读并同意
                <span class="link" @click.stop="showAgreement('1')">《用户协议》</span>
                和
                <span class="link" @click.stop="showAgreement('2')">《隐私协议》</span>
              </span>
            </template>
          </van-checkbox>
          <br>
          <van-button
            round
            block
            type="primary"
            native-type="submit"
            :disabled="!loginForm.agreement"
          >
            登录/注册
          </van-button>
        </div>
      </van-form>
    </div>
  </van-popup>

  <div class="logo" style="width: 100%;display: flex;justify-content: center;;"> 
    <img :src=logo alt="皮皮售" width="100%" height="160px" style="object-fit: contain;margin-top: -30px;" >
  </div>
  </div>
</template> 

<script>
import { showToast, showDialog,showLoadingToast,showSuccessToast,showFailToast,showConfirmDialog } from 'vant'
import request from '@/utils/request'
import appLogo from '@/assets/logo3.png';
export default {
  name: 'ProfilePage',
  data() {
    return {
      showLoginForm: false,
      loginForm: {
        phone: '',
        email: '',
        smsCode: '',
        inviteCode: '',
        agreement: false,
        loginType: 'phone'  // 新增：默认为手机登录
      },
      logo: appLogo,
      isSmsSending: false,
      smsCountdown: 60,
      smsButtonText: '发送验证码',
      isLoggedIn: false, // 登录状态
      userInfo: {},
      tranTotal: {},
      shopTotal:'',
      sellTotal:'',
      userStats: {
        weapons: 15,
        trades: 28,
        credit: 98
      },
      menuList: [
      
      ]
    }
  },
  created() {
     this.userInfo = this.$store.state.user.userInfo;
     if (this.userInfo.userId) {
       this.isLoggedIn = true;
       this.getTransactionTotal();
     } 
  },
  methods: {
    switchLoginType(type) {
      this.loginForm.loginType = type;
    },
    
    copyInviteCode() {
      if (!this.userInfo.inviteCode) {
        showToast('暂无邀请码');
        return;
      }
      
      navigator.clipboard.writeText(this.userInfo.inviteCode)
        .then(() => {
          showToast('邀请码已复制');
        })
        .catch(() => {
          showToast('复制失败，请重试');
        });
    },
    toWallet(){
      this.$router.push('/wallet')
    },
    onMenuClick(menu) {
      //跳转对应的页面
      this.$router.push(menu.routerPath)
    },
    toUserauth(){
      if(this.userInfo.verifyFlag!=1){
        this.$router.push('/userauth')
        return
      }
      showToast('已实名认证,无需再认证');
      
    },
    toChat(){
      (window.open('https://work.weixin.qq.com/kfid/kfc0afede0891281246'))
    },
    onLogout(){
      showConfirmDialog({
          message:
            '确定退出当前账户吗？',
        })
  .then(() => {
     request.post('/front/auth/logout', {}).then(res => {
          if(res.code == 200){
            localStorage.removeItem('token')
            this.isLoggedIn = false
            this.$store.state.user.userInfo = {}
            this.$router.push('/')
            showSuccessToast('退出成功');
          }
        })
    
  })
  .catch(() => {
    // on cancel
  });
    },
    onLogin() {
      this.loginForm = {}
      this.showLoginForm = true
    },
    async handleLogin() {
      try {
       let lgoinLoad = showLoadingToast({
          message: '登录中...',
          forbidClick: true,
          loadingType: 'spinner',
        });
        
       // 根据登录类型决定使用手机号还是邮箱登录
       const loginData = {
        platformType: '2',//1 PC 2 h5
        inviteCode: this.loginForm.inviteCode//邀请码
       };
       if (this.loginForm.loginType === 'phone') {
         if (!this.validatePhone()) {
           return;
         }
         loginData.smsCode = this.loginForm.smsCode,
         loginData.mobile = this.loginForm.phone;
       } else {
         if (!this.validateEmail()) {
           return;
         }
         loginData.code = this.loginForm.smsCode,
         loginData.email = this.loginForm.email;
       }
       let url;
       if (this.loginForm.loginType === 'phone') { 
          url = '/front/auth/login';
       } else {
          url = '/front/auth/emailLogin';
       }
       // 处理登录逻辑
      request.post(url, loginData).then(res => {
        if(res.code == 200){
          //成功登录
          localStorage.setItem('token',res.msg)
          showSuccessToast('登录成功');
          lgoinLoad.close()
          this.isLoggedIn = true
          this.showLoginForm = false
          this.$store.dispatch('user/getUserInfo').then(res => {
          if(res.code == 200){
          this.userInfo = res.data
          this.getTransactionTotal();
        }
        })
        }else {
          //登录失败
          showFailToast(res.msg);
        }
      })
      } catch (error) {
        showFailToast("登录失败");
      }
    },
    
    validatePhone() {
      if (!this.loginForm.phone) {
        showToast('请先输入手机号');
        return false;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.loginForm.phone)) {
        showToast('请输入正确的手机号');
        return false;
      }
      return true;
    },
    
    validateEmail() {
      if (!this.loginForm.email) {
        showToast('请先输入邮箱');
        return false;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.loginForm.email)) {
        showToast('请输入正确的邮箱格式');
        return false;
      }
      return true;
    },
    
    async sendSmsCode() {
      if (this.isSmsSending) return
      
      // 根据登录类型验证输入
      if (this.loginForm.loginType === 'phone') {
        if (!this.validatePhone()) {
          return;
        }
      } else {
        if (!this.validateEmail()) {
          return;
        }
      }
      
      this.isSmsSending = true
      this.smsButtonText = `${this.smsCountdown}s`
      
      // 根据登录类型发送验证码
      let apiUrl = '';
      if (this.loginForm.loginType === 'phone') {
        apiUrl = `/front/auth/sendCode/${this.loginForm.phone}`;
      } else {
        apiUrl = `/front/auth/sendEmailCode/${this.loginForm.email}`;
      }
      
      // 发送验证码的API调用
      request.get(apiUrl).then(res => {
        console.log(res)
        if(res.code == 200){
          //验证码返回成功
          showSuccessToast('验证码已发送');
        }else {
          //发送短信失败
          showFailToast(res.msg);
        }
      }).catch(error => {
        showFailToast('验证码发送失败，请稍后重试');
        this.isSmsSending = false;
      })
      
      const timer = setInterval(() => {
        this.smsCountdown--
        this.smsButtonText = `${this.smsCountdown}s`
        
        if (this.smsCountdown <= 0) {
          clearInterval(timer)
          this.isSmsSending = false
          this.smsCountdown = 60
          this.smsButtonText = '发送验证码'
        }
      }, 1000)



    },
    async getTransactionTotal(){
      request.get('/front/profile/transactionTotal')
      .then(result => {
        if(result.code == 200){
           this.tranTotal = result.data;
        }
      })
    },
    showAgreement(type) {
      if(type==1){
        showDialog({
          title: '用户协议',
          message: `
                <p>本《用户协议》（下亦简称"本协议"）的订立、履行、解释及争议的解决均适用中华人民共和国法律并排除一切冲突法的适用。</p>
            <p>本协议签订于台州市范成电子商务有限公司办公地点。如双方就本协议的内容或其执行发生任何争议（包括但不限于协议或者其他财产性权益纠纷），双方应友好协商解决；协商不成时，双方同意交由本协议签订地有管辖权的人民法院管辖并处理。</p>
            <h2>第一条 定义</h2>
            <div class="clause">
                <p><span class="highlight">1、用户</span>，是指通过台州市范成电子商务有限公司提供的合法途径，获得台州市范成电子商务有限公司非商业使用性质之授权，从而使用皮皮售平台或接受皮皮售平台服务进行交易的自然人。在本协议中，还可能用"您"来指代用户。除非本协议中另有明确说明，否则本协议中对用户的约定既适用于交易买方，也适用于交易卖方。</p>
            </div>
            <div class="clause">
                <p><span class="highlight">2、"皮皮售游戏饰品交易回收平台"</span>（下方简称为皮皮售平台），是指皮皮售平台网站（网址为www.ppstandoff2.com）。</p>
            </div>
            <div class="clause">
                <p><span class="highlight">3、游戏饰品</span>，是指俄罗斯游戏对峙2所提供的游戏内所存在的、可在该平台内的不同账号之间转移的游戏资源、游戏道具等可归属于特定主体的财产或财产性权益（包括但不限于游戏中的武器、坐骑、宠物、装备、皮肤等）。在本协议中，还可能用"交易标的"来指代游戏饰品。</p>
                <p>本协议以及皮皮售平台相关页面中所描述的"出售"、 "购买"、 "买"、 "卖"、 "交易"、"回收"等用词，均指且仅指前述财产或财产性权益及其交易对价在特定主体之间的转让行为。</p>
            </div>
            <div class="clause">
                <p><span class="highlight">4、皮皮售平台规则</span>，是指台州市范成电子商务有限公司在皮皮售平台上已经发布及后续不时发布的规则、解读、公告、通知、问答、帮助、交易流程说明等全部内容。</p>
            </div>

            <h2>第二条 用户的义务</h2>
            <p>皮皮售平台是台州市范成电子商务有限公司向用户提供的在线交易服务系统，用户需在严格遵守本协议及皮皮售平台规则的前提下，进行有关游戏饰品的交易。用户在使用皮皮售平台服务时，必须：</p>
            <ol>
                <li>自行提供设备，包括个人电脑或可移动智能设备（如智能手机、平板电脑）并自行配备上网装置。</li>
                <li>确保相关设备能成功连接至互联网并成功实现上网、支付等相关功能。</li>
                <li>拥有合法、有效并能顺利进行相关交易的对峙2游戏账号。</li>
            </ol>
            <p>同时，用户因进行交易或接受皮皮售平台服务而发生的所有应纳税赋以及其它方面的费用均由用户自行承担。</p>

            <h2>第三条 本协议的修订</h2>
            <p>台州市范成电子商务有限公司有权在必要时修订本协议的条款并通知用户。用户在使用皮皮售平台服务时，应当及时查阅了解修订的内容，并自觉遵守本协议的全部条款。</p>
            <p>本协议修订后，如用户继续使用台州市范成电子商务有限公司服务的，则视为该用户已经接受全部的修订；如用户不同意本协议或修订的任何部分的，应立即停止使用皮皮售平台及平台服务。</p>

            <h2>第四条 用户注册及账户使用须知</h2>
            <div class="clause">
                <h3>1、用户注册</h3>
                <p>用户在使用皮皮售平台服务之前，必须先进行注册以取得皮皮售平台的账号、密码（下亦统称"皮皮售平台账户"或简称"用户账户"、"账户"）。用户在此同意并确认：</p>
                <ul>
                    <li>皮皮售平台服务向符合中华人民共和国法律规定的具有完全民事行为能力、能够独立承担民事责任的自然人提供；</li>
                    <li>用户为限制民事行为能力人的，需在法定代理人的陪同下阅读本协议，并在取得法定代理人对用户使用皮皮售平台服务、向台州市范成电子商务有限公司支付费用的行为，以及对本协议全部条款的同意之后，方可使用皮皮售平台服务；</li>
                    <li>无民事行为能力人不得使用皮皮售平台服务。</li>
                    <li>用户有义务按照台州市范成电子商务有限公司于注册流程中的提示提供本人真实、准确、最新及完整的个人身份资料信息；如果用户提供任何不真实、不准确、不完整或不能反映当前情况的个人身份资料信息的，或台州市范成电子商务有限公司有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况的，台州市范成电子商务有限公司保留拒绝或停止用户使用皮皮售平台服务的权利。</li>
                    <li>用户确认并同意，用户向台州市范成电子商务有限公司提交的真实、准确、最新及完整的个人身份资料信息是证明用户与其注册的皮皮售平台账户关联的唯一有效证据。</li>
                    <li>用户在使用皮皮售平台服务的同时，同意接受台州市范成电子商务有限公司或其合作伙伴通过包括但不限于网站消息、电子邮件、手机短信等各种渠道发布的各类信息服务。</li>
                </ul>
            </div>
            <div class="clause">
                <h3>2、会员制度</h3>
                <p>用户可申请开通付费会员服务。用户应在充值服务界面通过台州市范成电子商务有限公司认可的支付方式完成支付以开通付费会员服务。用户在开通付费会员服务时，应仔细核对账户、开通服务类型等具体信息。用户在开通付费会员服务后，主张充错账户、选错服务类型的，台州市范成电子商务有限公司不予认可，不予退还已收取的费用。</p>
                <p>付费会员服务仅限于所对应的皮皮售平台账户之权利人通过该账户使用。用户应妥善保存有关账号、密码，并对该账户进行的所有活动和行为负责，禁止赠与、借用、租用、转让或售卖皮皮售平台账户。如因非台州市范成电子商务有限公司原因致使用户的皮皮售平台账号和/或密码泄漏，或因用户保管、使用、维护不当造成任何损失的，台州市范成电子商务有限公司无须承担与此有关的任何责任。</p>
                <p>关于皮皮售平台会员的会员制度、会员服务和会员活动均由台州市范成电子商务有限公司制定和发布。</p>
            </div>
            <div class="clause">
                <h3>3、资费政策</h3>
                <p>台州市范成电子商务有限公司有权就不同的产品和服务制定不同的资费标准和收费方式，且有权就所提供的产品和服务的不同阶段确定不同的资费标准和收费方式。具体收费方式、资费标准，将会在皮皮售平台网站及进行说明。</p>
                <p>用户有义务在选择前仔细阅读，一旦用户选择购买相关增值服务、虚拟物品使用权或者接受相关服务，则表明用户已经充分理解并接受相应的收费方式和资费标准。</p>
            </div>
            
            <div class="clause">
                <h3>4、用户的账号、密码和安全性</h3>
                <p>用户了解并同意，确保账号及密码的机密安全是用户的责任。用户应对利用其账号及密码所进行的一切行动及发表的一切言论，负完全的责任。用户在此明确同意，下列行为均为严重损害台州市范成电子商务有限公司权益的行为，如用户实施了下列行为中的一项或多项，台州市范成电子商务有限公司有权在不通知用户的情况下，终止向其提供付费会员服务，并有权限制、冻结或删除相应的皮皮售平台账户或清空其权益。就此台州市范成电子商务有限公司无须给予任何补偿或退费，由此产生的全部责任由用户自行承担。如因实施系列行为给台州市范成电子商务有限公司或第三方造成其他损失的，应由用户负责全额赔偿：</p>
                <ol>
                    <li>以非获得皮皮售平台服务以外的营利性目的，为自己或他人获得付费会员服务；</li>
                    <li>将账户以出租、出借、出售等任何形式提供给第三方使用；</li>
                    <li>将通过付费会员服务获得的任何内容用于使用皮皮售平台服务之外的用途；</li>
                    <li>盗用他人皮皮售平台账户进行付费会员注册或使用；</li>
                    <li>以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它非台州市范成电子商务有限公司认可的方式获得付费会员服务；</li>
                    <li>通过不正当手段或以违反诚实信用原则的行为获得付费会员服务；</li>
                    <li>其他因用户未妥善保管自己的账号或密码而对用户自身、台州市范成电子商务有限公司或第三方造成损害的。</li>
                </ol>
                <p>若用户发现有第三人冒用或盗用其自身的账号或密码，或存在任何其他未经合法授权之情形，应立即以有效方式通知台州市范成电子商务有限公司，并向皮皮售平台提供与所涉及的账号之注册信息相一致的个人身份资料信息。如皮皮售平台经核实确认您所提供的个人身份资料信息与注册时提交的个人身份资料信息相一致的，将采取措施对该账号进行限制或处理；若您没有提供个人身份资料信息或者所提供的个人身份资料信息与注册时提交的个人身份资料信息不一致的，皮皮售平台有权拒绝您的相关请求，在此情况下台州市范成电子商务有限公司对任何人使用该账号及密码所产生的一切后果，不承担任何责任。</p>
            </div>

            <h2>第五条 交易规则</h2>
            <div class="clause">
                <p>鉴于皮皮售平台仅为一个基于互联网的交易平台，台州市范成电子商务有限公司并不参与用户之间的交易。用户确认并同意，皮皮售平台的预估价、参考价、市场价等，仅仅是台州市范成电子商务有限公司为了更好地服务用户而提供给用户的参考信息，任何时候台州市范成电子商务有限公司的任何行为均不得被认为是对交易标的价格的合理性、交易标的来源的合法性等进行的任何明示或默示的担保或保证。</p>
                <p>但出于保障用户的合法权益之必要，用户同意授权台州市范成电子商务有限公司根据本协议约定及皮皮售平台规则对发生在皮皮售平台上的交易进行管理，用户对台州市范成电子商务有限公司据此进行的审查、调查、限制、处罚、责任追究等予以认可。</p>
            </div>
            <div class="clause">
                <p>若用户账户被盗、遭遇黑客攻击或出现其他异常情形的，在用户向台州市范成电子商务有限公司提出或台州市范成电子商务有限公司主动发现异常的情况下，为保护用户合法权益，台州市范成电子商务有限公司有权就用户账户及交易展开调查，并对用户的账户采取保护性的处理措施，包括但不限于暂时限制账户操作、皮皮售平台使用权限降级（包括但不限于限制提现、出售、购买、饰品检视、发表评论、昵称修改等）、资金冻结、中止或终止交易、撤销交易等。</p>
            </div>
            <div class="clause">
                <p>交易完成后，若经任何第三方举报或台州市范成电子商务有限公司主动发现交易异常的情形下，台州市范成电子商务有限公司有权对已完成交易展开调查，若经调查发现已完成交易确属违反法律法规或本协议，台州市范成电子商务有限公司将有权撤销该交易，在用户的皮皮售平台账户余额中扣除等额的交易款项、限制或禁止用户使用皮皮售平台账户、限制或禁止用户提取皮皮售平台账户余额等。</p>
            </div>
            <div class="clause">
                <p>您应知悉，由于网络服务的特性和复杂性，台州市范成电子商务有限公司可能难以及时发现用户账户或交易的异常情况，故为保障您的合法权益，请密切关注您的账户和交易情况，一旦发生异常请及时与台州市范成电子商务有限公司联系。</p>
            </div>

            <h2>第六条 抵扣币规则</h2>
            <p>抵扣币是皮皮售平台对用户特定行为（如参与平台活动，邀请码）的奖励，抵扣币可用于兑换饰品。抵扣币的获取及使用规则由台州市范成电子商务有限公司制定和发布。关于抵扣币的使用，用户同意并确认：</p>
            <ol>
                <li>抵扣币将记入用户作出特定行为时所使用的皮皮售平台账户且仅供该账户之权利人通过该账户使用，抵扣币不能转移，不能与其他用户的抵扣币叠加使用；</li>
                <li>抵扣币只能在皮皮售平台兑换、消费使用，不能直接套现或用于任何违反法律法规、本协议及台州市范成电子商务有限公司相关规则和政策等的用途；</li>
                <li>抵扣币存在有效期31天，当年6月30日（含当日）前获得的抵扣币，截至当年7月31日（含当日）有效；当年7月1日（含当日）后获得的抵扣币，截至次年8月2日（含当日）有效。过期抵扣币自动清除，用户将无法使用该部分抵扣币，但其他有效期内的抵扣币仍可正常使用；</li>
                <li>如用户违反相关规定，违规获取及/或使用抵扣币，台州市范成电子商务有限公司有权对该违规行为采取本协议第七条第9款中的处理措施，如因用户的违规行为给台州市范成电子商务有限公司及/或第三方造成损失的，用户应承担全部责任。</li>
            </ol>

            <h2>第七条 用户管理</h2>
            <div class="clause">
                <p>用户承诺在使用皮皮售平台服务时实施的所有行为均遵守中华人民共和国法律法规、对峙2及交易标的所属游戏之运营方的要求和本协议、皮皮售平台规则等。</p>
            </div>
            <div class="clause">
                <p>用户承诺在使用皮皮售平台进行交易的过程中遵守诚实信用的原则，不得从事欺诈、虚假或误导性活动。</p>
            </div>
            <div class="clause">
                <p>用户承诺在皮皮售平台所交易的交易标的之来源应符合法律法规规定、对峙2及交易标的所属游戏之运营方的要求、台州市范成电子商务有限公司发布的相关规则和政策等。对于出售通过欺诈、利用漏洞等违法违规手段获取的游戏饰品的行为，台州市范成电子商务有限公司有权根据本协议、皮皮售平台规则及台州市范成电子商务有限公司发布的相关规则和政策等采取处罚措施。</p>
            </div>
            <div class="clause">
                <p>用户在皮皮售平台以及相关网页上发布信息或者使用皮皮售平台的服务时，不得制作、复制、发布、传播以下信息：</p>
                <ol>
                    <li>违反中华人民共和国宪法所确定的基本原则的；</li>
                    <li>危害中华人民共和国国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</li>
                    <li>损害中华人民共和国国家荣誉和利益的；</li>
                    <li>煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                    <li>破坏中华人民共和国宗教政策，宣扬邪教和封建迷信的；</li>
                    <li>散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
                    <li>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</li>
                    <li>侮辱或者诽谤他人，侵害他人合法权益的；</li>
                    <li>含有中华人民共和国法律、行政法规禁止的其他内容的。</li>
                </ol>
            </div>
            <div class="clause">
                <p>用户不得利用皮皮售平台的服务从事以下活动：</p>
                <ol>
                    <li>未经允许，对计算机信息网络功能进行删除、修改或者增加；</li>
                    <li>未经允许，对计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</li>
                    <li>故意制作、传播计算机病毒等破坏性程序；</li>
                    <li>其他危害计算机信息网络安全的行为。</li>
                </ol>
            </div>
            <div class="clause">
                <p>用户不得以任何方式干扰皮皮售平台的服务，包括但不限于不得开发、支持或使用软件、设备、脚本、程序或采用任何技术手段恶意破坏皮皮售平台网站，干扰皮皮售平台正常运营等。</p>
            </div>
            <div class="clause">
                <p>用户须对自己在使用皮皮售平台服务过程中的行为承担法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在台州市范成电子商务有限公司首先承担了因用户行为导致的行政处罚或赔偿责任后，用户应对台州市范成电子商务有限公司的直接和间接损失进行赔偿。</p>
            </div>
            <div class="clause">
                <p>除非本协议另有约定，否则，未经台州市范成电子商务有限公司事先书面同意，用户不得实施下列行为（无论是营利的还是非营利的）：</p>
                <ol>
                    <li>复制、翻录、反编译（de-compile）、反汇编（disassemble）、传播和陈列皮皮售平台的程序、使用手册和其它图文音像资料的全部或部分内容，或对皮皮售平台的任何功能或程序进行反向工程（reverse engineering）。</li>
                    <li>公开展示和以各种形式、在各种平台（包括但不限于网络直播平台、网站、APP等）播放皮皮售平台服务的全部或部分内容、交易过程等。</li>
                    <li>出租、销售皮皮售平台或者利用皮皮售平台从事任何营利行为。</li>
                    <li>修改或遮盖皮皮售平台程序、图像、动画、包装和手册等内容上的服务名称、公司标志、商标或版权信息、其他知识产权声明等内容。</li>
                    <li>违反皮皮售平台的Robots协议或突破反爬虫技术措施，违法违规获取皮皮售平台上的信息、干扰皮皮售平台正常运营的行为。</li>
                    <li>其它违反商标法、著作权法、计算机软件保护条例和相关法律法规、国际条约的行为。</li>
                </ol>
            </div>
            <div class="clause">
                <p>经人民法院或行政机关的生效法律文书确认用户存在违法行为，或者台州市范成电子商务有限公司有足够事实依据可以认定用户存在违法或违反本协议、皮皮售平台规则之行为的，台州市范成电子商务有限公司有权选择下列一种或多种处理措施进行处理：</p>
                <ol>
                    <li>限制或禁止用户使用皮皮售平台账户，中止或终止用户交易权限；</li>
                    <li>禁止登陆、注销或删除用户账户；</li>
                    <li>修改或删除用户的用户名、头像等用户自定义资料，删除用户发布的相关信息；</li>
                    <li>扣除用户的皮皮售平台账户中的余额、限制或禁止用户提取皮皮售平台账户余额等；</li>
                    <li>扣除用户的皮皮售平台账户中的抵扣币；</li>
                    <li>对用户使用皮皮售平台的权限进行降级操作，包括但不限于限制提现、出售、购买、饰品检视、发表评论、昵称修改；</li>
                    <li>在皮皮售平台上以网络发布形式公布用户的违法/违约/违规行为。</li>
                </ol>
            </div>
            <div class="clause">
                <p>对于用户在皮皮售平台交易平台发布的下列各类信息，台州市范成电子商务有限公司有权在不通知用户的前提下进行删除或采取其他限制性和惩罚性措施，该类信息包括但不限于：</p>
                <ol>
                    <li>以规避交易费用为目的；</li>
                    <li>以恶意扰乱游戏虚拟饰品价格为目的；</li>
                    <li>台州市范成电子商务有限公司有理由相信存在欺诈等恶意或虚假内容；</li>
                    <li>台州市范成电子商务有限公司有理由相信与皮皮售平台交易无关或不是以交易为目的；</li>
                    <li>台州市范成电子商务有限公司有理由相信存在恶意竞价、恶意压价或其他试图扰乱正常交易秩序的因素；</li>
                    <li>台州市范成电子商务有限公司有理由相信该信息违反公共利益或可能严重损害本网站和其他用户合法利益的；</li>
                    <li>其他可能损害台州市范成电子商务有限公司、皮皮售平台及皮皮售平台的其他用户或公共利益的信息。</li>
                </ol>
            </div>
            <h2>第八条 知识产权以及其他权利归属</h2>
            <div class="clause">
                <p>对皮皮售平台上著作权、专利权、商标专用权及其它知识产权归台州市范成电子商务有限公司所有的全部作品及资料（包括但不限于文字、软件、声音、照片、录象、图表等），除非事先经台州市范成电子商务有限公司的明确授权，任何人皆不得擅自以任何形式使用，否则台州市范成电子商务有限公司有权立即终止向该等用户提供服务，并依法追究其法律责任。</p>
            </div>
            <div class="clause">
                <p>在使用皮皮售平台服务的过程中，用户可能需要通过上传、发布等各种方式向台州市范成电子商务有限公司提供内容。在此情况下，用户仍然享有此等内容的完整知识产权。</p>
                <p>用户在此明确同意，用户在提供前述内容的同时，不可撤销地授予台州市范成电子商务有限公司及其关联公司一项全球性的、永久的免费许可，允许台州市范成电子商务有限公司及其关联公司使用、传播、复制、修改、再许可、翻译、出版、表演及展示此等内容，以及使用此等内容创作衍生作品。</p>
            </div>

            <h2>第九条 服务的修改、中断以及终止</h2>
            <div class="clause">
                <p>台州市范成电子商务有限公司保留随时修改或中断皮皮售平台服务而不需事先通知用户的权利。</p>
            </div>
            <div class="clause">
                <p>为了网站的正常运行，台州市范成电子商务有限公司需要定期对网站进行停机维护或针对突发事件进行紧急停机维护；因上述情况而造成的正常服务暂时中断，用户应该予以理解，台州市范成电子商务有限公司则有义务尽力避免服务中断并将中断时间限制在最短时间内。</p>
            </div>
            <div class="clause">
                <p>经事先通知用户，台州市范成电子商务有限公司可根据业务实际需要终止皮皮售平台服务。用户同意：如台州市范成电子商务有限公司已将终止服务事宜事先通知用户的，就终止服务行为给用户造成的任何损失，台州市范成电子商务有限公司不需对用户或任何第三方负责。</p>
            </div>
            <div class="clause">
                <p>在下列情况下，台州市范成电子商务有限公司可以终止为特定用户提供服务：</p>
                <ol>
                    <li>在用户违反法律法规的相关规定或者本协议、皮皮售平台规则的相关约定时，台州市范成电子商务有限公司有权终止向该用户提供服务。如该用户在被台州市范成电子商务有限公司终止提供服务后，再次注册或以他人名义注册成为皮皮售平台用户的，台州市范成电子商务有限公司有权再次终止向该用户提供服务；</li>
                    <li>用户注册时提供的个人身份资料信息不真实的；</li>
                    <li>用户要求台州市范成电子商务有限公司终止向其提供服务，且台州市范成电子商务有限公司同意的；</li>
                    <li>其他按照双方约定或法律规定应终止的情形。</li>
                </ol>
            </div>
            <div class="clause">
                <p>台州市范成电子商务有限公司中断、终止对用户提供服务的，对服务中断、终止之前的用户交易行为，应依下列原则处理：</p>
                <ol>
                    <li>服务中断、终止之前，交易标的尚未交付给交易买方或尚未交付完成、交易买方尚未支付交易对价的，台州市范成电子商务有限公司有权在中断、终止服务的同时取消交易并删除此项交易标的的相关信息；</li>
                    <li>交易买方尚未支付交易对价的，交易标的将不会交付给交易买方，在此情形下如服务中断、终止，则台州市范成电子商务有限公司有权中断、终止服务，取消交易并将交易标的退回给交易卖方，同时删除此项交易标的的相关信息；</li>
                    <li>服务中断、终止之前，交易标的尚未交付给交易买方，但交易买方已经支付交易对价的，服务终止时，则台州市范成电子商务有限公司有权中断、终止服务，取消交易并将交易对价退回给交易买方，同时删除此项交易标的的相关信息；</li>
                    <li>服务终止情形下，用户账户内的全部抵扣币将自动清除，用户同意台州市范成电子商务有限公司不需对用户或任何第三方负责。</li>
                </ol>
            </div>
            <h2>第十条 责任限制</h2>
            <div class="clause">
                <p>用户在皮皮售平台所表达的观点、建议和其它内容均为用户本人看法，不代表台州市范成电子商务有限公司的观点。</p>
            </div>
            <div class="clause">
                <p>台州市范成电子商务有限公司对不可抗力导致的损失不承担责任。本服务协议所指不可抗力包括：天灾、法律法规、政府指令的变更、第三方应用平台原因、因网络服务特性而特有的原因（例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、突发性的软硬件设备及电子通信设备故障、互联网覆盖范围限制、计算机病毒、黑客攻击等因素等），及其他合法范围内的不能预见、不能避免并不能克服的客观情况。</p>
            </div>
            <div class="clause">
                <p>用户理解并同意，皮皮售平台的服务是按照现有技术和条件所能达到的现状提供的。台州市范成电子商务有限公司会尽最大努力向您提供服务，确保服务的连贯性和安全性；但台州市范成电子商务有限公司不能随时预见和防范技术风险以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、第三方服务干涉、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。台州市范成电子商务有限公司不能确保您从皮皮售平台下载的任何资料或其他数据无病毒、无污染或不具破坏性。</p>
                <p>由于网络环境特殊性及网络第三方不确定安全因素，台州市范成电子商务有限公司不承诺皮皮售平台或皮皮售平台的任何内容、服务或功能无任何错误或不中断，不承诺任何瑕疵将被纠正，或者您对皮皮售平台的使用将产生特定结果。</p>
                <div class="important">
                    <p>根据《中华人民共和国发票管理办法》及相关规定，我司仅对收取的服务费开具发票：</p>
                    <ol>
                        <li>我司开票内容为"服务费"。</li>
                        <li>如您需要开具发票，请提供用户名、订单号、姓名、手机号、身份证号码，收件地址，邮箱地址，并于交易完成一个月内申请，我司审核确认后，会在三个工作日内开具完成。</li>
                        <li>目前我司支持开具纸质发票、电子发票，纸质发票开具后会通过快递方式发送给您，快递费用由您承担（快递为到付）。</li>
                    </ol>
                </div>
                <p>如果对皮皮售平台或任何内容有任何不满意，您应当停止使用皮皮售平台或任何该等内容。救济限制是双方协议的一部分。</p>
            </div>
            <div class="clause">
                <p>对发生下列情形造成的不便或损害，台州市范成电子商务有限公司免责：</p>
                <ol>
                    <li>为了更好地为用户提供专业、便捷的服务而进行的网站和服务器的定期检查或施工、更新软硬件而造成的服务中断；</li>
                    <li>网络服务提供商线路或其他故障；</li>
                    <li>在紧急情况之下依照法律的规定或政府部门的指令而采取的措施；</li>
                    <li>用户与其它任何第三方的纠纷；</li>
                    <li>台州市范成电子商务有限公司根据已经生效的法律文书以及有效政府文件的要求进行的任何操作；</li>
                    <li>其他非台州市范成电子商务有限公司原因导致的情形。</li>
                </ol>
            </div>
            <div class="clause">
                <p>鉴于交易标的的特殊性，皮皮售平台无法鉴别和判断相关交易各主体之民事行为能力、资质、信用等状况，也无法鉴别和判断交易标的之来源、权属、真伪、性能、规格、质量、数量等属性及状况。因此，您在交易前应加以仔细辨明，并慎重考虑和评估交易可能产生的各项风险并自行承担由此带来的后果。</p>
            </div>
            <h2>第十一条 通知</h2>
            <p>台州市范成电子商务有限公司所有发给用户的通知可通过公告、电子邮件、站内信、纸质信件或其他形式发送。</p>
            <h2>第十二条 其他约定</h2>
            <div class="clause">
                <p>用户如对本协议有任何疑问，请登录皮皮售平台获取相关信息或通过电子客服或企业微信联系皮皮售平台。</p>
            </div>
            <div class="clause">
                <p>用户理解并同意，皮皮售平台服务的提供可能受到第三方对于包括但不限于应用开发、运营、交易、支付等相关规则的特定约束或限制。如用户使用皮皮售平台服务的行为因违反第三方的规则而导致交易无效或部分无效，双方可参照本协议第九条关于服务修改、中断或终止的约定进行处理，如因此产生任何损失的，台州市范成电子商务有限公司不承担任何责任，用户同意不向台州市范成电子商务有限公司进行任何形式的追诉。如本协议任何条款因法律规定、任何第三方规则、人民法院生效法律文书被判定为完全或部分无效或不具有执行力的，本协议的其他条款仍应有效并且有执行力。</p>
            </div>
            <div class="clause">
                <p>用户理解并同意，皮皮售平台可以在提供服务的过程中自行或由第三方广告商向您发送广告、推广或宣传信息（包括商业与非商业信息），其方式和范围可不经向用户特别通知而变更。用户应当自行判断广告信息的真实性并为自己的判断行为负责，除法律明确规定外，用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，皮皮售平台不承担责任。</p>
            </div>

  `,
  messageAlign: 'left',
  scrollable: true,
  maxHeight: '90vh',
  allowHtml: true, 
  // confirmButtonText: '我已阅读并同意',
  showCancelButton: false
        })

     
      }else{
        let content = `
           <p>本《隐私政策》（下亦简称"本协议"）适用于我们提供的一切皮皮售游戏饰品交易回收平台"（下方简称为皮皮售平台），是指皮皮售平台网站（网址为www.ppstandoff2.com）。</p>
                <p>当您使用我们任何单项服务时，您同意接受本《隐私政策》以及我们在该单项服务中发出的特定隐私信息类政策条款（下列称"特定条款"）的保护，在此情况下特定条款与本政策条款同时对您产生效力。</p>
                <p>请注意我们时不时地会检查我们的政策，因此有关的措施会随之变化。我们恳请您定期光顾本页面，以确保对我们《隐私政策》最新版本始终保持了解。在阅读完本政策之后，如您对本《隐私政策》或与本《隐私政策》相关的事宜有任何问题，请与皮皮售平台客服联系。</p>
                <p>您使用或继续使用皮皮售平台服务，都表示您同意我们按照本《隐私政策》收集、使用、储存和分享您的信息。</p>
            </div>

            <div class="section">
                <h2 class="section-title">一、我们可能收集的信息</h2>
                
                <div class="subsection">
                    <h3 class="subsection-title"><i class="fas fa-info-circle"></i> （一）与个人身份无关的信息：</h3>
                    <p>当您使用皮皮售平台服务时，我们可能收集和汇总诸如用户的来源途径、访问顺序等信息，例如记录使用皮皮售平台服务的每个用户的来源途径、浏览器软件等。</p>
                </div>
                
                <div class="subsection">
                    <h3 class="subsection-title"><i class="fas fa-id-card"></i> （二）有关个人身份的信息：</h3>
                    <p>当您使用皮皮售平台服务时，我们可能收集和汇总或要求您提供有关个人身份的信息，例如：</p>
                    <ul>
                        <li><strong>个人信息：</strong>生日、籍贯、性别、兴趣爱好、个人电话号码（包括系统账号、IP地址、电子邮箱地址等）；</li>
                        <li><strong>财产信息：</strong>交易记录、余额、优惠券、兑换码等；</li>
                        <li><strong>通讯信息；</strong></li>
                        <li><strong>上网记录和日志信息：</strong>网站浏览记录、软件使用记录、点击记录、操作日志等；</li>
                        <li><strong>设备信息：</strong>设备型号、设备MAC地址、操作系统类型、设备设置；</li>
                        <li><strong>设备识别信息：</strong>唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；</li>
                        <li><strong>位置信息：</strong>行程信息、精准定位信息、住宿信息、经纬度等。</li>
                    </ul>
                    
                    <div class="highlight">
                        <p>我们收集您的信息主要是为了您和其他用户能够更容易和更满意地使用皮皮售平台服务。皮皮售平台的目标是向所有的互联网用户提供安全、刺激、有趣及有教益的上网经历。而这些信息有助于我们实现这一目标。</p>
                    </div>
                </div>
            </div>

            <div class="section">
                <h2 class="section-title">二、我们如何收集和使用信息</h2>
                
                <div class="subsection">
                    <h3 class="subsection-title"><i class="fas fa-compress-arrows-alt"></i> （一）收集途径</h3>
                    <p>我们将通过以下途径收集和获得您的信息：</p>
                    
                    <div class="highlight">
                        <p>1. <strong>您提供的信息</strong>。例如：</p>
                        <ul>
                            <li>您在注册皮皮售平台服务的帐号或使用皮皮售平台服务时，向我们提供的信息；</li>
                            <li>您通过皮皮售平台服务向其他方提供的共享信息，以及您使用皮皮售平台服务时所储存的信息。</li>
                        </ul>
                        
                        <p>2. <strong>我们获取的您的信息</strong>。您在使用皮皮售平台服务时，我们收集、汇总、记录的信息，例如日志信息、位置信息、设备信息等。</p>
                    </div>
                </div>
                
                <div class="subsection">
                    <h3 class="subsection-title"><i class="fas fa-cookie-bite"></i> （二）COOKIES、日志档案和WEB BEACON</h3>
                    <p>我们或我们的第三方合作伙伴可能通过COOKIES和WEB BEACON获取和使用您的信息，并将该等信息储存为日志信息。通过使用COOKIES，我们向用户提供简单易行并富个性化的网络体验。一个COOKIES是少量的数据，它们从一个网络服务器送至您的浏览器并存在计算机硬盘上。</p>
                    
                    <div class="important">
                        <p>我们使用COOKIES是为了让其用户可以受益。比如，为使得皮皮售平台虚拟社区的登录过程更快捷，您可以选择把用户名存在一个COOKIES中。这样下次当您要登录皮皮售平台的服务时能更加方便快捷。COOKIES能帮助我们确定您连接的页面和内容，您在皮皮售平台特定服务上花费的时间和您所选择的皮皮售平台服务。</p>
                    </div>
                    
                    <p>COOKIES使得我们能更好、更快地为您服务，并且使您在皮皮售平台服务上的经历更富个性化。然而，您应该能够控制COOKIES是否以及怎样被你的浏览器接受。请查阅您的浏览器附带的文件以获得更多这方面的信息。</p>
                    
                    <p>我们使用自己的COOKIES和WEB BEACON，用于以下用途：</p>
                    
                    <ul>
                        <li><strong>记住您的身份：</strong>例如：COOKIES和WEB BEACON有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供有关您的喜好或其他信息；</li>
                        <li><strong>分析您使用我们服务的情况：</strong>我们可利用COOKIES和WEB BEACON来了解您使用皮皮售平台服务进行什么活动、或哪些服务或服务最受欢迎；</li>
                        <li><strong>广告优化：</strong>COOKIES和WEB BEACON有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。</li>
                    </ul>
                    
                    <div class="highlight">
                        <p>我们为上述目的使用COOKIES和WEB BEACON的同时，可能将通过COOKIES和WEB BEACON收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析您和其他用户如何使用皮皮售平台服务并用于广告服务。</p>
                    </div>
                    
                    <p>皮皮售平台服务上可能会有广告商和其他合作方放置的COOKIES和WEB BEACON。这些COOKIES和WEB BEACON可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。</p>
                    
                    <div class="important">
                        <p>这些第三方COOKIES和WEB BEACON收集和使用该等信息不受本《隐私政策》约束，而是受相关使用者的隐私政策约束，我们不对第三方的COOKIES或WEB BEACON承担责任。</p>
                    </div>
                </div>
            </div>
            
            
            
            
        </div>

        
        `
        showDialog({
          title: '隐私协议',
          message: content,
          messageAlign: 'left',
          scrollable: true,
          maxHeight: '90vh',
          allowHtml: true, 
          // confirmButtonText: '我已阅读并同意',
          showCancelButton: false
        })
      }
      

     
    }
  }
}
</script>

<style scoped>
.profile {
  background-color: #fff !important;
  height: 100vh !important;
  overflow-y: auto;
}

.user-card {
  background: white;
  padding: 20px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
}

.avatar {
  margin-right: 15px;
  width: 60px;
  height: 60px;
}

.user-details {
  flex: 1;
  margin-left: 50px;
}

.user-name-row {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.user-name-row h3 {
  margin: 0;
  font-size: 18px;
  color: #323233;
  margin-right: 8px;
}

.user-badges {
  display: flex;
  align-items: center;
  gap: 4px;
}

.vip-badge {
  filter: drop-shadow(0 0 2px rgba(255, 215, 0, 0.5));
}

.verified-badge {
  filter: drop-shadow(0 0 2px rgba(7, 193, 96, 0.3));
}

.user-details p {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #969799;
}

.user-status {
  display: flex;
  align-items: center;
  gap: 4px;
}

.stats-grid {
  background: white;
  margin-bottom: 10px;
}

.menu-section {
  margin-bottom: 10px;
  /* background-color: #f7f8fa; */
  background-color: #fff;
}

.guest-info {
  margin-bottom: 10px;
  background-color: #fff;
}

.auth-section {
  padding: 20px;
}

.vip-expired-dot {
  position: absolute;
  right: -8px;
  top: -8px;
  background: #ccc;
  color: #fff;
  font-size: 10px;
  border-radius: 8px;
  padding: 2px 6px;
  z-index: 2;
}
.login-form {
  padding: 16px 0;
}

.form-title {
  text-align: center;
  font-size: 18px;
  margin: 0 0 16px;
}

/* 登录方式切换标签页样式 */
.login-type-tabs {
  display: flex;
  margin: 0 20px 10px;
  border-bottom: 1px solid #eee;
}

.login-type-tabs span {
  flex: 1;
  text-align: center;
  cursor: pointer;
  padding: 8px 0;
  font-size: 14px;
  position: relative;
}

.login-type-tabs span.active-tab {
  color: #1989fa;
  font-weight: bold;
}

.login-type-tabs span.active-tab::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #1989fa;
  transform: scaleX(1);
}

.login-type-tabs span.inactive-tab {
  color: #969799;
}

.agreement-text {
  font-size: 12px;
  color: #666;
}

.link {
  color: #1989fa;
}

.wallet-card {
  background: linear-gradient(135deg, #1E2235, #2A2F45);
  border-radius: 12px;
  padding: 16px 20px;
  margin: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  color: #fff;
}

.wallet-info {
  display: flex;
  flex-direction: column;
}

.wallet-label {
  color: #a9a07a;
  font-size: 12px;
}

.wallet-amount {
  color: #e7c587;
  font-size: 24px;
  margin-top: 2px;
  font-weight: 500;
}


.currency {
  font-size: 16px;
  font-weight: bold;
  margin-right: 2px;
}

.amount {
  font-size: 24px;
  font-weight: bold;
  color: #e7c587;
}

.wallet-icon {
  color: #ff6b6b;
  opacity: 0.8;
}

::v-deep .van-grid-item__content {
  width: 100% !important;
  background-color: #fff !important;
}

::v-deep .van-grid{
  background-color: #fff !important;
}

::v-deep .agreement-dialog {
  width: 100%;
  /* max-width: 600px; */
}

::v-deep .agreement-dialog .van-dialog__message {
  line-height: 1.1;
  font-size: 14px;
  padding: 10px;
  overflow-y: auto;
}

.clause{
}
</style>
